import React, { useCallback, useEffect, useState } from "react";
import DetailsViewPreview from "./DetailsViewPreview";
import "../BuilderComponents/Preview/tabviewlib/TabViewRenderer.css";
import { BlockPreview, withAppBlockData } from "./PositionedElementPreview";
import { useAppBlocksContext } from "../../context/AppBlocksContext";

const DVGroupPreview = ({ config, device, type }) => {
  const [selectedTab, setSelectedTab] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [uniqueDvList, setUniqueDvList] = useState([]);
  const { allApplicationBlockData } = useAppBlocksContext();

  const EnhancedBlockPreview = withAppBlockData(BlockPreview);
  const renderEnhancedBlock = useCallback(
    (Component) => (
      <EnhancedBlockPreview
        config={{
          id: selectedTab,
          type: "detailview"
        }}
        device={device}
        type={type}
      >
        {(actualConfig) => <Component actualConfig={actualConfig} />}
      </EnhancedBlockPreview>
    ),
    [selectedTab, device, type]
  );

  const getUniqueDvList = useCallback(() => {
    const dvList = config?.dv_list || [];
    const defaultId = config?.default_dv_id;

    const seen = new Set();
    const uniqueList = [];

    for (const item of dvList) {
      if (!item?.dv_id || seen.has(item.dv_id)) continue;

      seen.add(item.dv_id);
      uniqueList.push(item);
    }

    if (defaultId && !seen.has(defaultId)) {
      uniqueList.push({
        dv_id: defaultId,
        isDefault: true
      });
    }

    return uniqueList;
  }, [config?.dv_list, config?.default_dv_id]);

  useEffect(() => {
    if (config?.dv_list?.length > 0 || config?.default_dv_id) {
      const newUniqueDvList = getUniqueDvList();
      setUniqueDvList(newUniqueDvList);

      if (newUniqueDvList.length > 0) {
        setSelectedTab(newUniqueDvList[0].dv_id);
      } else {
        setSelectedTab(null);
      }
    } else {
      setUniqueDvList([]);
      setSelectedTab(null);
    }
  }, [config?.dv_list, config?.default_dv_id, getUniqueDvList]);

  if (!config?.dv_list?.length && !config?.default_dv_id) {
    return (
      <div className="dv-group-preview-empty">
        <div>DetailsView Group</div>
      </div>
    );
  }

  return (
    <div
      className="dv-group-preview overflow_hidden h_100"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="tabview_renderer_outerbox static_field_blocks" style={{ position: "relative" }}>
        <div style={{ position: "relative", height: "100%" }}>
          {selectedTab ? renderEnhancedBlock(DetailsViewPreview) : <div>Page data not found</div>}
        </div>

        {type === "editable" && (uniqueDvList?.length > 0 || config?.default_dv_id) && (
          <div
            className={`d_flex dv-group-preview-tab position_absolute top_0 left_0 ${isHovered ? "tabview_tabhead_visible" : "tabview_tabhead_hidden"}`}
            onClick={(e) => e.stopPropagation()}
            style={{
              // zIndex: 10,
              opacity: isHovered ? 1 : 0,
              pointerEvents: isHovered ? "auto" : "none",
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(4px)",
              width: "fit-content"
            }}
          >
            {uniqueDvList.map((dvItem, index) => {
              const tabId = `${dvItem.dv_id}`;
              const isActive = selectedTab === tabId;
              const isDefault = dvItem.isDefault;

              return (
                <div
                  key={index}
                  className={`tabview_tabhead_item px_4 py_3 ${isActive ? "tabview_tabhead_item_active" : ""}`}
                  onClick={() => setSelectedTab(tabId)}
                  style={{
                    backgroundColor: isActive
                      ? isDefault
                        ? "rgba(34, 197, 94, 0.9)"
                        : "var(--builder-primary)"
                      : "var(--builder-active-primary)",
                    color: isActive ? "var(--builder-active-primary)" : "var(--builder-primary)",
                    transition: "all 0.2s ease-in-out"
                  }}
                >
                  {allApplicationBlockData[tabId]?.name || `DV ${index + 1}`}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default DVGroupPreview;
